import React from "react";
import { LocalizationHelperInstance } from "utils/helpers";
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import SnoozeForm from "./snoozeForm";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { TranslationKeys } from "translations";

function useSnoozeAction(
  id: number | string,
  type: WintSuperkollAPIModel.TodoType,
  onActionSubmit?: () => void,
  entityText?: string
) {
  const description =
    entityText ?? LocalizationHelperInstance.getFormattedMessage(`Common.TodoType_${type}`).toLowerCase();

  const snoozeActionDialog: DialogProps = {
    isOpen: false,
    title: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Snooze)} ${description}`,
    subTitle: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SnoozeUntilWhen),
    titleIcon: IconDefinitionConstants.WClock,
    dialogType: DialogEnums.DialogType.Content,
    actions: [
      {
        text: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Snooze)}!`,
        successMessage: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Common.SnoozeSuccessMessage,
          "",
          {
            type: description,
          }
        ),
      },
    ],
    children: <SnoozeForm entityId={id} type={type} />,
    onSubmit: onActionSubmit,
  };

  const snoozeAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Snooze),
    icon: IconDefinitionConstants.WClock,
    actionDialog: snoozeActionDialog,
  };

  return { snoozeAction, snoozeActionDialog };
}

export default useSnoozeAction;
